(function () {
  if (window.__discountToggleInit) return;
  window.__discountToggleInit = true;

  let isUpdating = false;
  let debounceTimer = null;
  let followUpTimers = [];

  function $all(sel, root = document) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function isSubscriptionSelected(root = document) {
    const sp = root.querySelector(
      'input[name="selling_plan"][data-sls-selling_plan]'
    );
    if (sp) {
      if (sp.value && sp.value !== "") return true;
      if (sp.getAttribute && sp.getAttribute("value")) return true;
      return false;
    }
    const selected = root.querySelector('input[name^="subs_type_"]:checked');
    if (selected) return selected.dataset.type === "subscription";

    const subAria = root.querySelector(
      '.sls-selling-plan-group-first-line[role="radio"][aria-label*="Subscribe"][aria-checked="true"]'
    );
    if (subAria) return true;

    const activeSub = root.querySelector(
      ".sls-option-container[data-selling-plan-group].sls-active"
    );
    return !!activeSub;
  }

  function getActiveSealPrice(scope) {
    const activePrice = scope.querySelector(
      ".sls-option-container.sls-active .sls-price .money"
    );
    if (!activePrice) return "";
    return activePrice.textContent.trim();
  }

  function setTextIfChanged(el, nextPrice) {
    if (!el || !nextPrice) return;
    if (el.textContent.trim() === nextPrice) return;
    el.textContent = nextPrice;
  }

  function syncPriceWrapper(wrapper, nextPrice) {
    $all(".price__sale .price-item--sale", wrapper).forEach((el) => {
      setTextIfChanged(el, nextPrice);
    });

    $all(".price__regular .price-item--regular", wrapper).forEach((el) => {
      setTextIfChanged(el, nextPrice);
    });
  }

  function updateProductPrice(scope) {
    const nextPrice = getActiveSealPrice(scope);
    if (!nextPrice) return;

    const wrappers = $all(".price-wrapper", scope);
    const targets = wrappers.length
      ? wrappers
      : $all(".product .price-wrapper");

    targets.forEach((wrapper) => {
      syncPriceWrapper(wrapper, nextPrice);
    });
  }

  function updateAddToCartPrice(scope) {
    $all(".js-product-submit-price", scope).forEach((priceEl) => {
      if (priceEl.hidden) return;

      const priceScope =
        priceEl.closest('form[action*="/cart/add"]') ||
        priceEl.closest(".product") ||
        scope;
      const nextPrice = getActiveSealPrice(priceScope);
      if (!nextPrice) return;
      if (priceEl.textContent.trim() === nextPrice) return;

      priceEl.textContent = nextPrice;
      priceEl.setAttribute("data-label", nextPrice);
    });
  }

  function updateUI() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const products = $all(".product");
      const roots = products.length ? products : [document];

      roots.forEach((scope) => {
        $all(".discount-image-block", scope).forEach((block) => {
          const formScope =
            block.closest('form[action*="/cart/add"]') || scope;
          const sub = isSubscriptionSelected(formScope);
          block.classList.toggle("hidden", sub);
        });

        updateProductPrice(scope);
        updateAddToCartPrice(scope);
      });
    } finally {
      queueMicrotask(function () {
        isUpdating = false;
      });
    }
  }

  function scheduleSync() {
    updateUI();
    clearTimeout(debounceTimer);
    followUpTimers.forEach(clearTimeout);
    followUpTimers = [];

    debounceTimer = setTimeout(function () {
      updateUI();
      followUpTimers = [
        setTimeout(updateUI, 100),
        setTimeout(updateUI, 250),
      ];
    }, 0);
  }

  function attachDelegatedListeners() {
    document.addEventListener("change", function (e) {
      if (
        e.target.matches(
          'input[name^="subs_type_"], input[name="selling_plan"][data-sls-selling_plan], .bundle-picker__input'
        )
      ) {
        scheduleSync();
      }
    });

    document.addEventListener("click", function (e) {
      if (
        e.target.closest(".sealsubs-container") ||
        e.target.closest(".bundle-picker")
      ) {
        scheduleSync();
      }
    });
  }

  function observeSeal() {
    const observed = new WeakSet();
    const mo = new MutationObserver(function () {
      scheduleSync();
    });

    function bindRoots() {
      $all(".sealsubs-container, .sealsubs-target-element").forEach((root) => {
        if (observed.has(root)) return;
        observed.add(root);
        mo.observe(root, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ["aria-checked", "class", "value"],
        });
      });
    }

    bindRoots();

    const boot = new MutationObserver(function () {
      bindRoots();
    });
    boot.observe(document.body, { childList: true, subtree: true });
  }

  window.__syncSealPrices = scheduleSync;

  function init() {
    attachDelegatedListeners();
    observeSeal();
    scheduleSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
